var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"el-icon-arrow-left padding8",on:{"click":_vm.navigateBack}}),_c('span',{staticClass:"bold padding8"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }